import React, { FunctionComponent } from 'react';
import './chat-input.scss';
import { FormikProps } from 'formik';

interface IChatInputProps {
  placeholder: string;
  field: FormikProps<void>;
  form: FormikProps<void>;
}

const ChatInput: FunctionComponent<IChatInputProps> = ({ field, form, ...props }): JSX.Element => (
  <input className="chat-input" {...field} {...props}/>
);

export default ChatInput;
